(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tee-care"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCompare(el){
    if(el.dataset.careReady) return;
    el.dataset.careReady = '1';

    var top     = el.querySelector('.subtle-care__layer--top');
    var plate   = el.querySelector('.subtle-care__inner-plate');
    var divider = el.querySelector('.subtle-care__divider');
    var handle  = el.querySelector('.subtle-care__handle');
    if(!top || !plate || !divider || !handle) return;

    var pct = 50, dragging = false;

    function paint(){
      var w = el.getBoundingClientRect().width;
      top.style.width    = pct + '%';
      divider.style.left = pct + '%';
      handle.style.left  = pct + '%';
      plate.style.width  = w + 'px';
    }
    function setFrom(clientX){
      var r = el.getBoundingClientRect();
      if(!r.width) return;
      var x = Math.max(0, Math.min(clientX - r.left, r.width));
      pct = x / r.width * 100;
      paint();
    }

    paint();
    window.addEventListener('resize', paint);

    el.addEventListener('pointerdown', function(e){
      dragging = true;
      if(el.setPointerCapture) el.setPointerCapture(e.pointerId);
      setFrom(e.clientX);
    });
    el.addEventListener('pointermove',   function(e){ if(dragging) setFrom(e.clientX); });
    el.addEventListener('pointerup',     function(){ dragging = false; });
    el.addEventListener('pointercancel', function(){ dragging = false; });
  }

  function initReveal(root){
    var rv = root.querySelectorAll('.rv');
    if(!('IntersectionObserver' in window)){
      Array.prototype.forEach.call(rv, function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    },{rootMargin:'0px 0px -10% 0px',threshold:.12});
    Array.prototype.forEach.call(rv, function(el){ io.observe(el); });
  }

  function init(scope){
    var roots = (scope || document).querySelectorAll('.subtle-care[data-care-root]');
    Array.prototype.forEach.call(roots, function(root){
      initReveal(root);
      Array.prototype.forEach.call(root.querySelectorAll('[data-care-compare]'), initCompare);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ init(); });
  } else {
    init();
  }

  /* theme editor: re-init when this section is added, or a block is reordered */
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var c = e.target.querySelector('[data-care-compare]');
    if(c) c.scrollIntoView({block:'center', behavior:'smooth'});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
